module.exports = __webpack_public_path__ + "static/media/money-bag.f6e86a4e.png";